import React from "react";
import colors from "../styles/main.scss";
import ActivitiesContainer from "./ActivititiesContainer";
import Select, { components } from "react-select";
import goalBadge from "../img/60minBadge.svg";
import chronograph from "../img/stop-watch-ticks-only.svg";
import { avatarOptions } from "../helpers/ddOptions";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { strings } from "../loc/langs";
import Confetti from "react-dom-confetti";
import { Checkmark } from "react-checkmark";

class Stopwatch extends React.Component {
  // 60 minutes is the default goal to show badge.
  GOAL_MINUTES = 60;
  LAST_CELEBRATED_DURATION_DIVIDER = 0;

  // Gets called when clicking on deleting stopwatch.
  handleDeleteClick = () => {
    this.props.deleteStopwatch(this.props.stopwatchindex);
  };

  // Change event handler.
  handleOnChange = event => {
    // Update the current stopwatch.
    // Take a copy of the current stopwatch.
    const updatedStopwatch = {
      ...this.props.stopwatch,
      [event.currentTarget.name]: event.currentTarget.value
    };

    this.props.updateStopwatch(this.props.stopwatchindex, updatedStopwatch);
  };

  // Change event handler for React-Select component.
  handleOnChangeReactSelect = selectValue => {
    // Update the current stopwatch.
    // Take a copy of the current stopwatch.
    const updatedStopwatch = {
      ...this.props.stopwatch,
      avatar: selectValue
    };

    this.props.updateStopwatch(this.props.stopwatchindex, updatedStopwatch);
  };

  checkIfConfettiShouldFire = (totalMinutes) => {
    const numBadges = this.getBadges(totalMinutes).length;

    if(numBadges < this.LAST_CELEBRATED_DURATION_DIVIDER) {
      this.LAST_CELEBRATED_DURATION_DIVIDER = numBadges;
      return false;
    }

    if(numBadges !== this.LAST_CELEBRATED_DURATION_DIVIDER) {
      this.LAST_CELEBRATED_DURATION_DIVIDER = numBadges;

      return true
    } else {
      return false
    }
  }

  getBadges = totalMinutes => {
    const badgeEls = [];
    const badgeCount = Math.floor(totalMinutes / this.GOAL_MINUTES);

    for (let i = 0; i < badgeCount; i++) {
      badgeEls.push(
        <img
          src={goalBadge}
          className="img-badge"
          alt="60 Minutes of Activity!"
          key={`badge-${i}`}
        />
      );
    }

    return badgeEls;
  };

  render() {
    // Destructuring
    const {
      name,
      avatar,
      totalMinutes,
      totalLowIntesityMinutes,
      totalHighIntensityMinutes
    } = this.props.stopwatch;

    const fireConfetti = this.checkIfConfettiShouldFire(totalMinutes);

    // React Select mods.
    const { Option, SingleValue } = components;
    const IconOption = props => (
      <Option {...props}>
        <img
          src={props.data.label}
          style={{ width: 30, textAlign: "center" }}
          alt=""
        />
      </Option>
    );
    const ValueOption = props => (
      <SingleValue {...props}>
        <img
          className=""
          src={props.data.label}
          style={{ width: 30, textAlign: "center" }}
          alt=""
        />
      </SingleValue>
    );

    // Confetti config.
    // original config
    const topConfig = {
      angle: "90",
      spread: "150",
      startVelocity: 45,
      elementCount: "190",
      dragFriction: 0.1,
      duration: "9000",
      stagger: 0,
      width: "10px",
      height: "10px",
      colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]
    };
    // new config
    const config = {
      angle: "90",
      spread: "61",
      startVelocity: "84",
      elementCount: "166",
      dragFriction: "0.11",
      duration: "7930",
      stagger: "7",
      width: "16px",
      height: "16px",
      colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]
    };

    return (
      <div
        className={`stopwatch ${
          totalMinutes >= this.GOAL_MINUTES ? "goal-met" : "goal-not-met"
        }`}
      >
        <Confetti
          className="confetti-left"
          active={fireConfetti}
          config={topConfig}
        />
        <Confetti
          className="confetti-right"
          active={fireConfetti}
          config={topConfig}
        />
        <div className="top-row-container">
          <div className="success-badge">{this.getBadges(totalMinutes)}</div>
          {this.props.canDelete ? (
            <div className="btn-delete">
              <button
                type="button"
                title={strings["DeleteStopwatch"]}
                onClick={this.handleDeleteClick}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
          ) : null}
        </div>

        <h1 className="stopwatch-header">
          <img
            src={avatar.label}
            style={{ width: 64, textAlign: "center" }}
            alt=""
          />{" "}
          {this.props.stopwatch.name}
        </h1>
        <div className="chronograph-container">
          <img src={chronograph} className="img-chronograph" alt="" />
          {totalMinutes >= this.GOAL_MINUTES && (
            <div className="checkmark-container">
              <Checkmark size={50} />
            </div>
          )}
          <div
            className={`total-minutes-container ${
              totalMinutes >= this.GOAL_MINUTES ? "goal-met" : ""
            }`}
          >
            <span className="total-count">{totalMinutes}</span>
            <span className="min-txt">{strings["Mins"]}</span>
          </div>

          <div
            className="chart-container"
            style={{
              position: "absolute",
              height: 185,
              width: 185,
              top: 105,
              left: "50%",
              transform: "translateX(-50%)"
            }}
          >
            <CircularProgressbarWithChildren
              value={(totalHighIntensityMinutes / 60) * 100}
              strokeWidth={6}
              styles={buildStyles({
                pathColor: `${colors.highintensity}`,
                trailColor: "#ece8e8"
              })}
            >
              <div style={{ width: "80%" }}>
                <CircularProgressbar
                  value={(totalLowIntesityMinutes / 60) * 100}
                  strokeWidth={7}
                  styles={buildStyles({
                    pathColor: `${colors.lowintensity}`,
                    trailColor: "#ece8e8"
                  })}
                />
              </div>
            </CircularProgressbarWithChildren>
          </div>
        </div>

        <div className="name-container">
          <div className="input-container">
            <input
              type="text"
              name="name"
              value={name}
              placeholder={strings["EnterYourName"]}
              onChange={this.handleOnChange}
            />
            <Select
              name="avatar"
              value={avatar}
              onChange={this.handleOnChangeReactSelect}
              options={avatarOptions}
              components={{ Option: IconOption, SingleValue: ValueOption }}
              isSearchable={false}
              placeholder="Choose an avatar!"
              className="avatar"
              classNamePrefix="av"
              menuPlacement="top"
            />
          </div>
        </div>

        <ActivitiesContainer
          stopwatchindex={this.props.stopwatchindex}
          stopwatch={this.props.stopwatch}
          updateStopwatch={this.props.updateStopwatch}
          addActivity={this.props.addActivity}
          updateActivity={this.props.updateActivity}
          deleteActivity={this.props.deleteActivity}
        />

        <Confetti
          className="confetti-center"
          active={fireConfetti}
          config={config}
        />
      </div>
    );
  }
}

export default Stopwatch;
